

import { useEffect, useRef } from "react";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";

export default function ThreeJs() {
    const mountRef = useRef(null);

    useEffect(() => {
        const mount = mountRef.current;

        // === THREE BASIC SETUP ===
        const scene = new THREE.Scene();
        // scene.background = new THREE.Color(0x111218);
        scene.background = new THREE.Color(0xffffff);

        const camera = new THREE.PerspectiveCamera(
            50,
            mount.clientWidth / mount.clientHeight,
            0.1,
            100
        );
        camera.position.set(2.5, 2, 3);

        const renderer = new THREE.WebGLRenderer({ antialias: true });
        renderer.setSize(mount.clientWidth, mount.clientHeight);
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
        mount.appendChild(renderer.domElement);

        // === CONTROLS ===
        const controls = new OrbitControls(camera, renderer.domElement);
        controls.enableDamping = true;

        // === OBJECT ===
        // const box = new THREE.Mesh(
        //     new THREE.BoxGeometry(1.4, 1.4, 1.4),
        //     new THREE.MeshStandardMaterial({ color: 0x4a90e2 })
        // );
        // scene.add(box);
        // === OUTER BOX (wireframe container) ===
        const outerGeometry = new THREE.BoxGeometry(4, 6, 4);
        const outerMaterial = new THREE.MeshBasicMaterial({
            color: 0x000000,
            wireframe: true,
        });
        const outerBox = new THREE.Mesh(outerGeometry, outerMaterial);
        scene.add(outerBox);

        //this is style one
        // === STACKED BOXES (inside the outer box) ===
        const boxes = [];
        const boxCount = 5;
        const totalHeight = 5; // inside space
        const startY = -totalHeight / 2;

        for (let i = 0; i < boxCount; i++) {
            const width = THREE.MathUtils.randFloat(1, 3);
            const depth = THREE.MathUtils.randFloat(1, 3);
            const height = THREE.MathUtils.randFloat(0.7, 1.5);

            const geo = new THREE.BoxGeometry(width, height, depth);
            const mat = new THREE.MeshStandardMaterial({
                color: new THREE.Color(Math.random(), Math.random(), Math.random()),
                roughness: 0.4,
                metalness: 0.1,
            });

            const mesh = new THREE.Mesh(geo, mat);

            // positioned like stacked boxes
            const yPos =
                startY +
                boxes.reduce((acc, b) => acc + b.userData.h, 0) +
                height / 2;

            mesh.position.set(
                THREE.MathUtils.randFloatSpread(1),
                yPos,
                THREE.MathUtils.randFloatSpread(1)
            );

            mesh.userData.h = height; // store height for stacking

            boxes.push(mesh);
            scene.add(mesh);
        }

        // === LIGHTS ===
        scene.add(new THREE.AmbientLight(0xffffff, 0.4));
        const dir = new THREE.DirectionalLight(0xffffff, 0.9);
        dir.position.set(5, 10, 7);
        scene.add(dir);

        // === ANIMATION LOOP ===
        let frameId;
        const animate = () => {
            frameId = requestAnimationFrame(animate);
            // box.rotation.y += 0.01;
            // box.rotation.x += 0.01;
            controls.update();
            renderer.render(scene, camera);
        };
        animate();

        // === RESIZE HANDLER ===
        const handleResize = () => {
            const width = mount.clientWidth;
            const height = mount.clientHeight;
            renderer.setSize(width, height);
            camera.aspect = width / height;
            camera.updateProjectionMatrix();
        };
        window.addEventListener("resize", handleResize);

        // === CLEANUP ON UNMOUNT ===
        return () => {
            cancelAnimationFrame(frameId);
            window.removeEventListener("resize", handleResize);
            mount.removeChild(renderer.domElement);
            renderer.dispose();
            box.geometry.dispose();
            box.material.dispose();
        };
    }, []);

    return (
        <div
            ref={mountRef}
            style={{
                width: "100vw",
                height: "100vh",
                overflow: "hidden",
            }}
        />
    );
}